import type { ActionPolicy, PolicyRule } from "@veritrellis/shared";
import type { BuilderState } from "./builderTypes.js";

/**
 * Converts builder UI state to the canonical ActionPolicy object
 * accepted by PUT /admin/workspaces/:id/policies/:env/:type.
 */
export const serializeToPolicy = (state: BuilderState): ActionPolicy => {
  if (state.mode !== "conditional") {
    return { mode: state.mode };
  }

  const rules: PolicyRule[] = state.rules
    .filter((r) => r.conditions.length > 0)
    .map((r) => {
      const base: PolicyRule = {
        when: r.conditions.map(({ field, op, value }) => ({ field, op, value })),
        then: r.decision
      };
      if (r.decision === "require_modified_parameters" && r.modifications != null) {
        return { ...base, modifications: r.modifications };
      }
      if (r.decision === "require_approval") {
        return {
          ...base,
          ...(r.approverGroupId != null ? { approver_group_id: r.approverGroupId } : {}),
          ...(r.permitTtlSeconds != null ? { permit_ttl_seconds: r.permitTtlSeconds } : {})
        };
      }
      return base;
    });

  return {
    mode: "conditional",
    auto_allow_low_risk: state.autoAllowLowRisk || undefined,
    rules: rules.length > 0 ? rules : undefined,
    default_decision: state.defaultDecision
  };
};
